import _ from 'lodash'
import i18n from '@/lang'
import useIdToFindCategory from './use-id-to-find-category'

/**
 * useIdToFindCategory
 * @param {{category: Array, categoryId: Number}} param0
 */

export default function useIdToFindCategoryParent({ category, categoryId }) {
  if (!_.isArray(category)) {
    throw new Error(i18n.t('playTurbo.creative.useIdToFindResourceList.warning4'))
  }

  const cate = _.cloneDeep(useIdToFindCategory({ category, categoryId }))
  const cateParent = [cate]
  const rec = cateObject => {
    if (cateObject.pid) {
      const parentCate = _.cloneDeep(useIdToFindCategory({
        category,
        categoryId: cateObject.pid
      }))
      cateParent.push(parentCate)
      rec(parentCate)
    }
  }
  rec(cate)
  return cateParent
}
